import React from "react";
import "./../styles/globals/global.scss";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

function PaswordValidation({
  charsNumber,
  lowcase,
  uppercase,
  hasNumber,
  specialChar,
}) {
  return (
    <div className="pwdContainer">
      <div
        className={`${charsNumber ? "passedCheck" : "notPassedCheck"}`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <p className="mr-2">8 characters</p>
        {charsNumber ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
      </div>
      <div
        className={`${lowcase ? "passedCheck" : "notPassedCheck"}`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <p className="mr-2">1 lowercase</p>
        {lowcase ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
      </div>
      <div
        className={`${uppercase ? "passedCheck" : "notPassedCheck"}`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <p className="mr-2">1 uppercase</p>
        {uppercase ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
      </div>
      <div
        className={`${hasNumber ? "passedCheck" : "notPassedCheck"}`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <p className="mr-2">1 number</p>
        {hasNumber ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
      </div>
      <div
        className={`${specialChar ? "passedCheck" : "notPassedCheck"}`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <p className="mr-2">1 special character</p>
        {specialChar ? <TaskAltIcon /> : <RadioButtonUncheckedIcon />}
      </div>
    </div>
  );
}

export default PaswordValidation;
